var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.supplierCharge"),
        width: "1500px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                attrs: {
                  "config-module": "20240305",
                  reset: true,
                  "auto-init": _vm.searchItemAutoInit,
                  "show-simple": false,
                  "expand-adv": true,
                  "custom-search-items": _vm.customSearchItems
                },
                on: {
                  "click-more": function(value) {
                    return (_vm.isAdvancedQuery = value)
                  },
                  advSearchItemCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "operations" }, slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { no: "button1", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.toPassChargeSyncOut()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.confirmCharge")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "button2", type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.toNotPassChargeSyncOut()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "button3", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.toRefresh()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Refresh")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "2024030501",
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c(
                  "div",
                  { staticClass: "total-wrapper fixedBottom" },
                  [
                    _c("charge-currency-total-group", {
                      attrs: {
                        "ar-field": "receivable",
                        "currency-field": "currency",
                        "data-field": "amount",
                        "data-provider":
                          _vm.selectedRows.length > 0
                            ? _vm.selectedRows
                            : _vm.rowData,
                        "ar-label": _vm.$t("Message.Receivable"),
                        "ap-label": _vm.$t("Message.Payable")
                      }
                    })
                  ],
                  1
                ),
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "990011",
                    total: _vm.total,
                    "page-count": _vm.pageCount,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.toQueryByPage
                  }
                })
              ],
              1
            ),
            _vm.rejectWindow.visible
              ? _c("reject-dialog", {
                  attrs: {
                    visible: _vm.rejectWindow.visible,
                    "job-no": _vm.rejectWindow.jobNo,
                    "reject-call-back": _vm.rejectWindow.rejectCallBack,
                    "append-to-body": true
                  },
                  on: {
                    "update:visible": function($event) {
                      return _vm.$set(_vm.rejectWindow, "visible", $event)
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }